import { render } from "./baseAllArticles.vue?vue&type=template&id=79a732c2"
import script from "./baseAllArticles.vue?vue&type=script&lang=js"
export * from "./baseAllArticles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__